import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  statusType: {
    display: 'block',
    width: 100,
  },
  amountStack: {
    fontWeight: 'bold',
    display:'flex',
    justifyContent: 'flex-end'
  },
  logo: {
    fill: theme.palette.neutralPrimary,
  },
  cellContainer: {
    height: 25,
  },
  checkboxContainer: {
    flex: 0.2,
    justifyContent: 'end',
  },
  rowBaseStyle: { borderLeft: `5px solid transparent` },
}));
